/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Trans } from '@lingui/macro';

const style: ouiStyle.InStyleWithMediaQueries = {
  color: ouiStyle.Constants.Colors.inherit,
  textDecoration: 'none',
  fontSize: 'inherit',
  textTransform: 'uppercase',
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const DisclaimerLink = () => (
  <a
    href="#disclaimer"
    css={css}
  >
    <Trans>Avertissement</Trans>
  </a>
);
